import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { resetErrorMessage } from '../actions';

import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';

import clsx from 'clsx';
import useStyles from '../styles/Styles';

const ErrorDisplay = (props) => {
	const errorMessage = useSelector(state => state.errorMessage);
	const dispatch = useDispatch();
	const classes = useStyles();
	
	return _.isEmpty(errorMessage) ? null : (
		<Paper className={clsx(classes.innerContent, classes.page)} square={true}>
			<Grid container spacing={1} className={classes.bannerGrid}>
				<Grid container item spacing={1}>
					<Grid item>
					<ErrorIcon className={classes.errorSnack} />
					</Grid>
					<Grid item>
					<Typography variant="subtitle2"> Error</Typography>
					</Grid>
				</Grid>
				<Grid item >
					<Typography variant="body1">{errorMessage}</Typography>
				</Grid>
				<Grid container item justifyContent="flex-end" spacing={1} wrap="nowrap" >
					{props.extra_button ? (
					<Grid item>
					<Button color="primary" {...props.extra_button.atts} >{props.extra_button.text}</Button>
					</Grid>
					) : null}
					{props.hide_main_button ? null :
					<Grid item>
					<Button color="primary" onClick={() => dispatch(resetErrorMessage())}>Dismiss</Button>
					</Grid>
					}
				</Grid>
			</Grid>
			
			
		</Paper>
	)
}

export default ErrorDisplay